<template>
    <div class="data-evaluation-page">
        <!-- 企业主体合规 -->
        <el-card class="compliance-card" shadow="hover">
            <div slot="header" class="compliance-card-header">
                <i class="el-icon-office-building"></i>
                <span>企业主体合规</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="upload-label">
                        <span class="required-star">*</span>
                        <span class="label-title">资质证明材料</span>
                        <span class="label-hint">资质证书或经营许可证书</span>
                    </div>
                    <el-upload ref="ziZhiUpload" drag action='#' :auto-upload="false" :on-change="handleZiZhiFileChange"
                        :on-remove="handleZiZhiRemove" :file-list="ziZhiFiles" :limit="10" :multiple="true"
                        accept=".pdf,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <p class="file-list-title">已选择文件:</p>
                    <div v-if="ziZhiFiles.length > 0" style="max-height: 180px; overflow-y: auto;">
                        <el-table :data="ziZhiFiles" style="width: 100%;" border>
                            <el-table-column prop="name" label="文件名" min-width="180">
                                <template slot-scope="scope">
                                    <span style="display: flex; align-items: center;">
                                        <i :class="getFileTypeIcon(scope.row.name)" style="margin-right: 8px;"></i>
                                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.name }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="ziZhiFiles.length > 0 && ziZhiFiles.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                label="大小" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status === 'ready'" type="info" size="small">待上传</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploading'" type="warning" size="small">上传中</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploaded'" type="success" size="small">上传完成</el-tag>
                                    <el-tag v-if="scope.row.status === 'error'" type="danger" size="small">上传失败</el-tag>
                                    <el-progress v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                        :percentage="scope.row.percentage" :show-text="false" :stroke-width="6"></el-progress>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="singleZiZhiFileUpload(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">
                                        {{ scope.row.status === 'uploaded' ? '重新上传' : '上传' }}
                                    </el-button>
                                    <el-button type="text" @click="removeZiZhiFile(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="empty-file-hint">暂无文件</div>
                    <div class="upload-actions">
                        <el-button @click="clearZiZhiFiles" :disabled="ziZhiFiles.length === 0 || isZiZhiUploading">清空列表</el-button>
                        <el-button type="primary" @click="allZiZhiFilesUpload" :disabled="ziZhiFiles.length === 0 || isZiZhiUploading">批量上传</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据来源合规 -->
        <el-card class="compliance-card" shadow="hover">
            <div slot="header" class="compliance-card-header">
                <i class="el-icon-connection"></i>
                <span>数据来源合规</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="upload-label">
                        <span class="required-star">*</span>
                        <span class="label-title">数据来源证明材料</span>
                        <div class="label-hint-block">
                            根据数据来源不同，上传对应的材料：<br>
                            <b>原始取得：</b>须提交设备/系统的买卖或租赁合同。如若系统为企业自己研发，可提交软件著作权登记证书。<br>
                            <b>继受所得：</b>须提交权利转移相关的合同、合作协议、授权文书等。<br>
                            <b>交易所得：</b>须提交数据交易的凭证。
                        </div>
                    </div>
                    <el-upload ref="laiYuanUpload" drag action='#' :auto-upload="false"
                        :on-change="handleLaiYuanFileChange" :on-remove="handleLaiYuanRemove" :file-list="laiYuanFiles"
                        :limit="10" :multiple="true" accept=".pdf,.doc,.docx,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 DOC、DOCX、PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <p class="file-list-title">已选择文件:</p>
                    <div v-if="laiYuanFiles.length > 0" style="max-height: 180px; overflow-y: auto;">
                        <el-table :data="laiYuanFiles" style="width: 100%;" border>
                            <el-table-column prop="name" label="文件名" min-width="180">
                                <template slot-scope="scope">
                                    <span style="display: flex; align-items: center;">
                                        <i :class="getFileTypeIcon(scope.row.name)" style="margin-right: 8px;"></i>
                                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.name }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="laiYuanFiles.length > 0 && laiYuanFiles.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                label="大小" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status === 'ready'" type="info" size="small">待上传</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploading'" type="warning" size="small">上传中</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploaded'" type="success" size="small">上传完成</el-tag>
                                    <el-tag v-if="scope.row.status === 'error'" type="danger" size="small">上传失败</el-tag>
                                    <el-progress v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                        :percentage="scope.row.percentage" :show-text="false" :stroke-width="6"></el-progress>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="singleLaiYuanFileUpload(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">
                                        {{ scope.row.status === 'uploaded' ? '重新上传' : '上传' }}
                                    </el-button>
                                    <el-button type="text" @click="removeLaiYuanFile(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="empty-file-hint">暂无文件</div>
                    <div class="upload-actions">
                        <el-button @click="clearLaiYuanFiles" :disabled="laiYuanFiles.length === 0 || isLaiYuanUploading">清空列表</el-button>
                        <el-button type="primary" @click="allLaiYuanFilesUpload" :disabled="laiYuanFiles.length === 0 || isLaiYuanUploading">批量上传</el-button>
                    </div>
                </el-col>
            </el-row>

            <!-- 隐私/敏感数据选项 -->
            <el-divider></el-divider>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="inline-radio-group">
                        <span class="required-star">*</span>
                        <span class="label-title" style="margin-right: 16px;">数据是否涉及隐私、敏感数据：</span>
                        <el-radio-group v-model="needBeProcessed">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </el-col>
            </el-row>

            <!-- 数据脱敏处理证明材料 -->
            <div v-if="needBeProcessed">
                <el-divider></el-divider>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <div class="upload-label">
                            <span class="required-star">*</span>
                            <span class="label-title">数据脱敏处理证明材料</span>
                            <div class="label-hint-block">
                                数据涉及隐私、敏感数据：需提供100条数据脱敏样例。<br>
                                上传材料格式：Excel、PDF、图片
                            </div>
                        </div>
                        <el-upload ref="yinSiUpload" drag action='#' :auto-upload="false" :on-change="handleYinSiFileChange"
                            :on-remove="handleYinSiRemove" :file-list="yinSiFiles" :limit="10" :multiple="true"
                            accept=".xls,.xlsx,.pdf,.jpg,.png">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">点击或拖拽文件到此处<br>
                                <span style="color: gray; font-size: 10px;">
                                    支持文件大小不得超过{{ fileSizeLimit }}M</span>
                            </div>
                        </el-upload>
                    </el-col>
                    <el-col :span="16">
                        <p class="file-list-title">已选择文件:</p>
                        <div v-if="yinSiFiles.length > 0" style="max-height: 180px; overflow-y: auto;">
                            <el-table :data="yinSiFiles" style="width: 100%;" border>
                                <el-table-column prop="name" label="文件名" min-width="180">
                                    <template slot-scope="scope">
                                        <span style="display: flex; align-items: center;">
                                            <i :class="getFileTypeIcon(scope.row.name)" style="margin-right: 8px;"></i>
                                            <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.name }}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    v-if="yinSiFiles.length > 0 && yinSiFiles.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                    label="大小" width="100">
                                    <template slot-scope="scope">
                                        {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) : '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态" width="100">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.status === 'ready'" type="info" size="small">待上传</el-tag>
                                        <el-tag v-if="scope.row.status === 'uploading'" type="warning" size="small">上传中</el-tag>
                                        <el-tag v-if="scope.row.status === 'uploaded'" type="success" size="small">上传完成</el-tag>
                                        <el-tag v-if="scope.row.status === 'error'" type="danger" size="small">上传失败</el-tag>
                                        <el-progress v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                            :percentage="scope.row.percentage" :show-text="false" :stroke-width="6"></el-progress>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="120">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="singleYinSiFileUpload(scope.$index)"
                                            :disabled="scope.row.status === 'uploading'">
                                            {{ scope.row.status === 'uploaded' ? '重新上传' : '上传' }}
                                        </el-button>
                                        <el-button type="text" @click="removeYinSiFile(scope.$index)"
                                            :disabled="scope.row.status === 'uploading'">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else class="empty-file-hint">暂无文件</div>
                        <div class="upload-actions">
                            <el-button @click="clearYinSiFiles" :disabled="yinSiFiles.length === 0 || isYinSiUploading">清空列表</el-button>
                            <el-button type="primary" @click="allYinSiFilesUpload" :disabled="yinSiFiles.length === 0 || isYinSiUploading">批量上传</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <!-- 数据存储合规 -->
        <el-card class="compliance-card" shadow="hover">
            <div slot="header" class="compliance-card-header">
                <i class="el-icon-data-line"></i>
                <span>数据存储合规</span>
            </div>
            <div class="inline-radio-group" style="margin-bottom: 20px;">
                <span class="required-star">*</span>
                <span class="label-title" style="margin-right: 16px;">数据存储方式：</span>
                <el-radio-group v-model="isSelfStorage">
                    <el-radio :label="true">自行存储</el-radio>
                    <el-radio :label="false">非自行存储</el-radio>
                </el-radio-group>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="upload-label">
                        <span class="required-star">*</span>
                        <span class="label-title">数据存储证明材料</span>
                        <div class="label-hint-block">
                            <b>自行存储：</b>企业签署并上传《自行存储合规承诺书》。<br>
                            <el-link type="primary" :underline="true" @click="downloadTemplate('ComplianceCommitmentLetter.docx')">
                                《自行存储合规承诺书-模板》
                            </el-link><br><br>
                            <b>非自行存储：</b>上传与第三方机构合作的相关租赁协议或合作协议，并上传第三方存储合规承诺书。<br>
                            <el-link type="primary" :underline="true" @click="downloadTemplate('OtherComplianceCommitmentLetter.docx')">
                                《第三方存储合规承诺书-模板》
                            </el-link>
                        </div>
                    </div>
                    <el-upload ref="cunChuUpload" drag action='#' :auto-upload="false"
                        :on-change="handleCunChuFileChange" :on-remove="handleCunChuRemove" :file-list="cunChuFiles"
                        :limit="10" :multiple="true" accept=".pdf,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <p class="file-list-title">已选择文件:</p>
                    <div v-if="cunChuFiles.length > 0" style="max-height: 180px; overflow-y: auto;">
                        <el-table :data="cunChuFiles" style="width: 100%;" border>
                            <el-table-column prop="name" label="文件名" min-width="180">
                                <template slot-scope="scope">
                                    <span style="display: flex; align-items: center;">
                                        <i :class="getFileTypeIcon(scope.row.name)" style="margin-right: 8px;"></i>
                                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.name }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="cunChuFiles.length > 0 && cunChuFiles.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                label="大小" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status === 'ready'" type="info" size="small">待上传</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploading'" type="warning" size="small">上传中</el-tag>
                                    <el-tag v-if="scope.row.status === 'uploaded'" type="success" size="small">上传完成</el-tag>
                                    <el-tag v-if="scope.row.status === 'error'" type="danger" size="small">上传失败</el-tag>
                                    <el-progress v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                        :percentage="scope.row.percentage" :show-text="false" :stroke-width="6"></el-progress>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="singleCunChuFileUpload(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">
                                        {{ scope.row.status === 'uploaded' ? '重新上传' : '上传' }}
                                    </el-button>
                                    <el-button type="text" @click="removeCunChuFile(scope.$index)"
                                        :disabled="scope.row.status === 'uploading'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="empty-file-hint">暂无文件</div>
                    <div class="upload-actions">
                        <el-button @click="clearCunChuFiles" :disabled="cunChuFiles.length === 0 || isCunChuUploading">清空列表</el-button>
                        <el-button type="primary" @click="allCunChuFilesUpload" :disabled="cunChuFiles.length === 0 || isCunChuUploading">批量上传</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- <div style="margin-top: 30px; text-align: center;">
            <el-button type="danger" size="medium" @click="close('/DataCompliance')" :disabled="isSubmitting"
                style="width: 80px;">
                关闭
            </el-button>
            <el-button type="primary" size="medium" @click="submitEvaluation" :disabled="isSubmitDisabled"
                style="width: 150px;">
                {{ isSubmitting ? '提交中...' : '提交合规评估' }}
            </el-button>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'DataComplianceTemp',
    props: {
        registrationId: {
            type: String,
            default: ''
        },
        userId: {
            type: String,
            default: ''
        },
        complianceInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            fileSizeLimit: 100, // 文件大小限制，单位MB
            allFileList: [],
            ziZhiFiles: [],
            laiYuanFiles: [],
            yinSiFiles: [],
            cunChuFiles: [],

            needBeProcessed: true,
            allFileUploaded: false,

            isSelfStorage: true,
            companyAndAssetInfo: {},
            // registrationId: '',
            // userId: '',
            uploadedFileUrls: [],
            fileTypesMap: new Map(), // 记录文件与其类型的映射关系
            isSubmitting: false, // 控制提交状态
            submitConfirmInstance: null, // 保存提交确认弹窗的引用

            // 新增：上传状态控制
            isZiZhiUploading: false,
            isLaiYuanUploading: false,
            isYinSiUploading: false,
            isCunChuUploading: false,

            // 新增：上传状态汇总
            hasUploadingFiles: false,
            hasUnuploadedFiles: false,

            isInitialized: false

        }
    },
    created() {
        console.log('接收到的参数:', {
            registrationId: this.registrationId,
            userId: this.userId,
            complianceInfo: this.complianceInfo
        });
        // 格式化字符串为数组
        this.formatComplianceInfo();

        // this.initFormData()

        // 初始时更新一次状态
        this.$nextTick(() => {
            this.updateUploadStatus();
        });
    },
    mounted() {
        // this.$nextTick(() => {
        //     if (this.complianceInfo && Object.keys(this.complianceInfo).length > 0) {
        //         console.log('mounted 中处理 complianceInfo:', this.complianceInfo);
        //         this.formatComplianceInfo();
        //     }
        //     this.updateUploadStatus();
        // });
    },
    watch: {
        // 监听文件列表变化
        ziZhiFiles: {
            handler() {
                this.updateUploadStatus();
            },
            deep: true
        },
        laiYuanFiles: {
            handler() {
                this.updateUploadStatus();
            },
            deep: true
        },
        yinSiFiles: {
            handler() {
                this.updateUploadStatus();
            },
            deep: true
        },
        cunChuFiles: {
            handler() {
                this.updateUploadStatus();
            },
            deep: true
        },
        needBeProcessed() {
            // 当脱敏处理选项变化时更新状态
            this.updateUploadStatus();
        },
        // 监听 complianceInfo 变化
        complianceInfo: {
            handler(newVal, oldVal) {
                console.log('complianceInfo 发生变化:', { newVal, oldVal });
                // 只有当新值存在且与旧值不同时才重新格式化
                if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    console.log('重新格式化合规信息');
                    // 重置初始化标记
                    this.isInitialized = false;
                    // 重新格式化数据
                    this.$nextTick(() => {
                        this.formatComplianceInfo();
                    });
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        // 格式化 complianceInfo 中的字符串为数组
        formatComplianceInfo() {
            console.log('开始格式化合规信息:', this.complianceInfo);
            // 如果已经初始化过，避免重复处理
            if (this.isInitialized) {
                console.log('已经初始化过，但强制重新格式化');
                // 清空现有数据
                this.ziZhiFiles = [];
                this.laiYuanFiles = [];
                this.yinSiFiles = [];
                this.cunChuFiles = [];
                this.uploadedFileUrls = [];
            }

            // 处理资质证明材料
            if (this.complianceInfo.qualificationMaterials) {
                console.log('资质证明材料:', this.complianceInfo.qualificationMaterials);
                this.ziZhiFiles = this.parseMaterialsToFileList(
                    this.complianceInfo.qualificationMaterials,
                    'qualificationMaterials'
                );
            } else {
                this.ziZhiFiles = [];
            }

            // 处理数据来源证明材料
            if (this.complianceInfo.dataSourceMaterials) {
                console.log('数据来源证明材料:', this.complianceInfo.dataSourceMaterials);
                this.laiYuanFiles = this.parseMaterialsToFileList(
                    this.complianceInfo.dataSourceMaterials,
                    'dataSourceMaterials'
                );
            } else {
                this.laiYuanFiles = [];
            }

            // 处理数据样例证明材料
            if (this.complianceInfo.dataSampleMaterials) {
                console.log('数据样例证明材料:', this.complianceInfo.dataSampleMaterials);
                this.yinSiFiles = this.parseMaterialsToFileList(
                    this.complianceInfo.dataSampleMaterials,
                    'dataSampleMaterials'
                );
            } else {
                this.yinSiFiles = [];
            }

            // 处理数据存储证明材料
            if (this.complianceInfo.dataStorageMaterials) {
                console.log('数据存储证明材料:', this.complianceInfo.dataStorageMaterials);
                this.cunChuFiles = this.parseMaterialsToFileList(
                    this.complianceInfo.dataStorageMaterials,
                    'dataStorageMaterials'
                );
            } else {
                this.cunChuFiles = [];
            }

            // 设置其他属性 - 确保转换为布尔类型
            if (this.complianceInfo.isSelfStorage !== undefined) {
                this.isSelfStorage = this.convertToBoolean(this.complianceInfo.isSelfStorage);
            } else {
                this.isSelfStorage = true; // 默认值
            }

            if (this.complianceInfo.needBeProcessed !== undefined) {
                this.needBeProcessed = this.convertToBoolean(this.complianceInfo.needBeProcessed);
            } else {
                this.needBeProcessed = true; // 默认值
            }

            console.log('格式化后的文件列表:', {
                ziZhiFiles: this.ziZhiFiles,
                laiYuanFiles: this.laiYuanFiles,
                yinSiFiles: this.yinSiFiles,
                cunChuFiles: this.cunChuFiles
            });
            // 标记已初始化
            this.isInitialized = true;

            // 更新上传状态
            this.updateUploadStatus();
        },

        // 转换为布尔类型的辅助方法
        convertToBoolean(value) {
            if (typeof value === 'boolean') {
                return value;
            }

            if (typeof value === 'string') {
                // 处理字符串类型的布尔值
                const lowerValue = value.toLowerCase().trim();
                if (lowerValue === 'true' || lowerValue === '1' || lowerValue === '是') {
                    return true;
                }
                if (lowerValue === 'false' || lowerValue === '0' || lowerValue === '否') {
                    return false;
                }
            }

            if (typeof value === 'number') {
                return value !== 0;
            }

            // 默认返回 Boolean(value)
            return Boolean(value);
        },

        // 新增：重置组件状态的方法
        resetComponent() {
            console.log('重置子组件状态');

            // 重置初始化标记
            this.isInitialized = false;

            // 重新格式化数据
            if (this.complianceInfo && Object.keys(this.complianceInfo).length > 0) {
                this.formatComplianceInfo();
            }

            // 更新上传状态
            this.updateUploadStatus();
        },
        // 新增：解析材料字符串为文件列表的通用方法
        parseMaterialsToFileList(materialsString, fileType) {
            if (!materialsString) return [];

            let fileUrls = [];

            // 尝试解析 JSON 字符串
            if (typeof materialsString === 'string') {
                try {
                    // 尝试解析 JSON 字符串
                    const parsed = JSON.parse(materialsString);
                    if (Array.isArray(parsed)) {
                        fileUrls = parsed;
                    } else if (typeof parsed === 'string') {
                        // 如果是字符串，按逗号分割
                        fileUrls = parsed.split(',').map(url => url.trim()).filter(url => url);
                    } else {
                        // 其他类型，直接作为单个元素
                        fileUrls = [materialsString];
                    }
                } catch (e) {
                    // 如果不是 JSON，按逗号分割或直接作为单个元素
                    if (materialsString.includes(',')) {
                        fileUrls = materialsString.split(',').map(url => url.trim()).filter(url => url);
                    } else {
                        fileUrls = [materialsString];
                    }
                }
            } else if (Array.isArray(materialsString)) {
                // 如果已经是数组，直接使用
                fileUrls = materialsString;
            } else {
                // 其他类型，转换为字符串处理
                fileUrls = [String(materialsString)];
            }

            // 创建文件对象
            return fileUrls.map(url => this.createFileObject(url, fileType));
        },


        // 新增：根据 URL 创建文件对象
        createFileObject(url, fileType) {
            // 从 URL 中提取文件名
            const fileName = this.extractFileNameFromUrl(url) || '已上传文件';

            // 添加到已上传文件URL列表
            if (!this.uploadedFileUrls.some(item => item.url === url)) {
                this.uploadedFileUrls.push({
                    url: url,
                    type: fileType,
                    fileName: fileName
                });
            }

            return {
                name: fileName,
                url: url,
                status: 'uploaded', // 标记为已上传
                percentage: 100,
                uploaded: true,
                // 添加 raw 属性以兼容上传逻辑
                raw: {
                    name: fileName,
                    size: 0 // 未知大小
                }
            };
        },

        // 从 URL 中提取文件名
        extractFileNameFromUrl(url) {
            if (!url) return '已上传文件';

            try {
                // 尝试解析 URL
                if (url.includes('/')) {
                    const parts = url.split('/');
                    const fileName = parts[parts.length - 1];
                    // 解码 URL 编码的文件名
                    return decodeURIComponent(fileName);
                }
                return url;
            } catch (e) {
                console.error('解析文件名失败:', e);
                return '已上传文件';
            }
        },

        // async initFormData() {
        //     try {
        //         const response = await this.getRequest(`/web/dataAssets/query?userId=${this.userId}&dataAssetsId=${this.registrationId}`);
        //         console.log("response------------------------");
        //         console.log(response);
        //     }
        //     catch { }
        //     finally { }
        // },

        formatDateTime(dateTime) {
            if (!dateTime) return '-'

            const date = new Date(dateTime)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')

            return `${year}-${month}-${day}`
        },

        // 获取文件类型图标
        getFileTypeIcon(fileName) {
            const extension = fileName.toLowerCase().split('.').pop();
            switch (extension) {
                case 'pdf':
                    return 'el-icon-document';
                case 'jpg':
                case 'jpeg':
                case 'png':
                    return 'el-icon-picture';
                case 'doc':
                case 'docx':
                    return 'el-icon-document';
                case 'xls':
                case 'xlsx':
                    return 'el-icon-document';
                default:
                    return 'el-icon-document';
            }
        },

        // 格式化文件大小
        formatFileSize(size) {
            if (size < 1024) {
                return size + ' B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + ' KB';
            } else {
                return (size / (1024 * 1024)).toFixed(2) + ' MB';
            }
        },

        validateFile(file, allowExcel = false, allowWord = false) {
            // ... existing validateFile code ...
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];

            if (allowExcel) {
                allowedTypes.push('application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                allowedExtensions.push('.xls', '.xlsx');
            }

            if (allowWord) {
                allowedTypes.push('application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                allowedExtensions.push('.doc', '.docx');
            }

            const fileTypeValid = allowedTypes.includes(file.raw.type);
            const fileExtensionValid = allowedExtensions.some(ext =>
                file.name.toLowerCase().endsWith(ext)
            );

            if (!fileTypeValid || !fileExtensionValid) {
                let message = '';
                if (allowExcel && !allowWord) {
                    message = '只支持 Excel 格式的文件';
                } else if (!allowExcel && allowWord) {
                    message = '只支持 Word 格式的文件';
                } else if (allowExcel && allowWord) {
                    message = '只支持 Word 和 Excel 格式的文件';
                } else {
                    message = '只支持 PDF、JPG 和 PNG 格式的文件';
                }
                this.$message.error(message);
                return false;
            }

            const maxSize = this.fileSizeLimit * 1024 * 1024;
            if (file.raw.size > maxSize) {
                this.$message.error(`文件大小不能超过 ${this.fileSizeLimit} MB`);
                return false;
            }

            return true;
        },

        // 初始化文件状态
        initializeFileStatus(file) {
            return {
                ...file,
                status: 'ready',
                percentage: 0,
                uploaded: false
            };
        },

        // 资质文件相关方法
        handleZiZhiFileChange(file, fileList) {
            if (!this.validateFile(file)) {
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }

            // 检查是否已存在同名文件
            const existingFile = this.ziZhiFiles.find(f => f.name === file.name);
            if (existingFile) {
                this.$message.warning(`文件 ${file.name} 已存在`);
                return false;
            }

            const fileWithStatus = this.initializeFileStatus(file);
            this.ziZhiFiles.push(fileWithStatus);
            this.allFileList.push(fileWithStatus);

            console.log('添加新的资质文件:', file.name);

            // 更新上传状态
            this.updateUploadStatus();

            return true;
        },

        removeZiZhiFile(index) {
            const file = this.ziZhiFiles[index];

            // 从 uploadedFileUrls 中移除对应的 URL
            if (file.url) {
                const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                if (urlIndex > -1) {
                    this.uploadedFileUrls.splice(urlIndex, 1);
                }
            }

            // 从 allFileList 中移除
            const allFileIndex = this.allFileList.indexOf(file);
            if (allFileIndex > -1) {
                this.allFileList.splice(allFileIndex, 1);
            }

            // 从 ziZhiFiles 中移除
            this.ziZhiFiles.splice(index, 1);

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('文件已删除');
        },

        handleZiZhiRemove(file, fileList) {
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.ziZhiFiles = fileList.map(f => this.initializeFileStatus(f));
        },

        clearZiZhiFiles() {
            // 从 uploadedFileUrls 中移除所有资质文件的 URL
            this.ziZhiFiles.forEach(file => {
                if (file.url) {
                    const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                    if (urlIndex > -1) {
                        this.uploadedFileUrls.splice(urlIndex, 1);
                    }
                }
            });

            // 从 allFileList 中移除所有资质文件
            this.ziZhiFiles.forEach(file => {
                const index = this.allFileList.indexOf(file);
                if (index > -1) {
                    this.allFileList.splice(index, 1);
                }
            });

            // 清空 ziZhiFiles
            this.ziZhiFiles = [];

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('资质文件列表已清空');
        },

        async singleZiZhiFileUpload(index) {
            const file = this.ziZhiFiles[index];
            try {
                await this.uploadSingleFileWithProgress(file, 'qualificationMaterials', index, 'ziZhi');
                // 上传成功后触发事件
                this.$nextTick(() => {
                    this.triggerUploadStatusChange();
                });
            } catch (error) {
                console.error('单个资质文件上传失败:', error);
            }
        },

        async allZiZhiFilesUpload() {
            this.isZiZhiUploading = true;
            // 初始更新上传状态
            this.updateUploadStatus();

            try {
                for (let i = 0; i < this.ziZhiFiles.length; i++) {
                    const file = this.ziZhiFiles[i];
                    if (file.status !== 'uploaded') {
                        await this.uploadSingleFileWithProgress(file, 'qualificationMaterials', i, 'ziZhi');
                        // 每个文件上传后都触发一次状态更新
                        this.$nextTick(() => {
                            this.triggerUploadStatusChange();
                        });
                    }
                }
                this.$message.success('所有资质文件上传完成');
            } catch (error) {
                this.$message.error('上传过程中出现错误');
            } finally {
                this.isZiZhiUploading = false;
                // 最终更新上传状态
                this.updateUploadStatus();
            }
        },


        // 来源文件相关方法
        handleLaiYuanFileChange(file, fileList) {
            if (!this.validateFile(file, false, true)) {
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            const fileWithStatus = this.initializeFileStatus(file);
            this.laiYuanFiles.push(fileWithStatus);
            this.allFileList.push(fileWithStatus);

            // 更新上传状态
            this.updateUploadStatus();
        },

        removeLaiYuanFile(index) {
            const file = this.laiYuanFiles[index];

            // 从 uploadedFileUrls 中移除对应的 URL
            if (file.url) {
                const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                if (urlIndex > -1) {
                    this.uploadedFileUrls.splice(urlIndex, 1);
                }
            }

            // 从 allFileList 中移除
            const allFileIndex = this.allFileList.indexOf(file);
            if (allFileIndex > -1) {
                this.allFileList.splice(allFileIndex, 1);
            }

            // 从 laiYuanFiles 中移除
            this.laiYuanFiles.splice(index, 1);

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('文件已删除');
        },

        handleLaiYuanRemove(file, fileList) {
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.laiYuanFiles = fileList.map(f => this.initializeFileStatus(f));
        },

        clearLaiYuanFiles() {
            // 从 uploadedFileUrls 中移除所有来源文件的 URL
            this.laiYuanFiles.forEach(file => {
                if (file.url) {
                    const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                    if (urlIndex > -1) {
                        this.uploadedFileUrls.splice(urlIndex, 1);
                    }
                }
            });

            // 从 allFileList 中移除所有来源文件
            this.laiYuanFiles.forEach(file => {
                const index = this.allFileList.indexOf(file);
                if (index > -1) {
                    this.allFileList.splice(index, 1);
                }
            });

            // 清空 laiYuanFiles
            this.laiYuanFiles = [];

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('来源文件列表已清空');
        },

        async singleLaiYuanFileUpload(index) {
            const file = this.laiYuanFiles[index];
            await this.uploadSingleFileWithProgress(file, 'dataSourceMaterials', index, 'laiYuan');
        },

        async allLaiYuanFilesUpload() {
            this.isLaiYuanUploading = true;
            // 更新上传状态
            this.updateUploadStatus();
            try {
                for (let i = 0; i < this.laiYuanFiles.length; i++) {
                    const file = this.laiYuanFiles[i];
                    if (file.status !== 'uploaded') {
                        await this.uploadSingleFileWithProgress(file, 'dataSourceMaterials', i, 'laiYuan');
                    }
                }
                this.$message.success('所有来源文件上传完成');
            } catch (error) {
                this.$message.error('上传过程中出现错误');
            } finally {
                this.isLaiYuanUploading = false;
                // 更新上传状态
                this.updateUploadStatus();
            }
        },

        // 隐私文件相关方法
        handleYinSiFileChange(file, fileList) {
            if (!this.validateFile(file, true, false)) {
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            const fileWithStatus = this.initializeFileStatus(file);
            this.yinSiFiles.push(fileWithStatus);
            this.allFileList.push(fileWithStatus);

            // 更新上传状态
            this.updateUploadStatus();
        },

        removeYinSiFile(index) {
            const file = this.yinSiFiles[index];

            // 从 uploadedFileUrls 中移除对应的 URL
            if (file.url) {
                const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                if (urlIndex > -1) {
                    this.uploadedFileUrls.splice(urlIndex, 1);
                }
            }

            // 从 allFileList 中移除
            const allFileIndex = this.allFileList.indexOf(file);
            if (allFileIndex > -1) {
                this.allFileList.splice(allFileIndex, 1);
            }

            // 从 yinSiFiles 中移除
            this.yinSiFiles.splice(index, 1);

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('文件已删除');
        },

        handleYinSiRemove(file, fileList) {
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.yinSiFiles = fileList.map(f => this.initializeFileStatus(f));
        },

        clearYinSiFiles() {
            // 从 uploadedFileUrls 中移除所有隐私文件的 URL
            this.yinSiFiles.forEach(file => {
                if (file.url) {
                    const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                    if (urlIndex > -1) {
                        this.uploadedFileUrls.splice(urlIndex, 1);
                    }
                }
            });

            // 从 allFileList 中移除所有隐私文件
            this.yinSiFiles.forEach(file => {
                const index = this.allFileList.indexOf(file);
                if (index > -1) {
                    this.allFileList.splice(index, 1);
                }
            });

            // 清空 yinSiFiles
            this.yinSiFiles = [];

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('隐私文件列表已清空');
        },

        async singleYinSiFileUpload(index) {
            const file = this.yinSiFiles[index];
            await this.uploadSingleFileWithProgress(file, 'dataSampleMaterials', index, 'yinSi');
        },

        async allYinSiFilesUpload() {
            this.isYinSiUploading = true;
            // 更新上传状态
            this.updateUploadStatus();
            try {
                for (let i = 0; i < this.yinSiFiles.length; i++) {
                    const file = this.yinSiFiles[i];
                    if (file.status !== 'uploaded') {
                        await this.uploadSingleFileWithProgress(file, 'dataSampleMaterials', i, 'yinSi');
                    }
                }
                this.$message.success('所有隐私文件上传完成');
            } catch (error) {
                this.$message.error('上传过程中出现错误');
            } finally {
                this.isYinSiUploading = false;
                // 更新上传状态
                this.updateUploadStatus();
            }
        },


        // 存储文件相关方法

        handleCunChuFileChange(file, fileList) {
            if (!this.validateFile(file)) {
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }

            // 检查是否已存在同名文件
            const existingFile = this.cunChuFiles.find(f => f.name === file.name);
            if (existingFile) {
                this.$message.warning(`文件 ${file.name} 已存在`);
                return false;
            }

            const fileWithStatus = this.initializeFileStatus(file);
            this.cunChuFiles.push(fileWithStatus);
            this.allFileList.push(fileWithStatus);

            console.log('添加新的存储文件:', file.name);

            // 更新上传状态
            this.updateUploadStatus();

            return true;
        },

        removeCunChuFile(index) {
            const file = this.cunChuFiles[index];

            // 从 uploadedFileUrls 中移除对应的 URL
            if (file.url) {
                const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                if (urlIndex > -1) {
                    this.uploadedFileUrls.splice(urlIndex, 1);
                }
            }

            // 从 allFileList 中移除
            const allFileIndex = this.allFileList.indexOf(file);
            if (allFileIndex > -1) {
                this.allFileList.splice(allFileIndex, 1);
            }

            // 从 cunChuFiles 中移除
            this.cunChuFiles.splice(index, 1);

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('文件已删除');
        },

        handleCunChuRemove(file, fileList) {
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.cunChuFiles = fileList.map(f => this.initializeFileStatus(f));
        },


        clearCunChuFiles() {
            // 从 uploadedFileUrls 中移除所有存储文件的 URL
            this.cunChuFiles.forEach(file => {
                if (file.url) {
                    const urlIndex = this.uploadedFileUrls.findIndex(item => item.url === file.url);
                    if (urlIndex > -1) {
                        this.uploadedFileUrls.splice(urlIndex, 1);
                    }
                }
            });

            // 从 allFileList 中移除所有存储文件
            this.cunChuFiles.forEach(file => {
                const index = this.allFileList.indexOf(file);
                if (index > -1) {
                    this.allFileList.splice(index, 1);
                }
            });

            // 清空 cunChuFiles
            this.cunChuFiles = [];

            // 更新上传状态并通知父组件
            this.updateUploadStatus();

            this.$message.success('存储文件列表已清空');
        },

        async singleCunChuFileUpload(index) {
            const file = this.cunChuFiles[index];
            try {
                await this.uploadSingleFileWithProgress(file, 'dataStorageMaterials', index, 'cunChu');
                // 上传成功后触发事件
                this.$nextTick(() => {
                    this.triggerUploadStatusChange();
                });
            } catch (error) {
                console.error('单个存储文件上传失败:', error);
            }
        },

        async allCunChuFilesUpload() {
            this.isCunChuUploading = true;
            // 初始更新上传状态
            this.updateUploadStatus();

            try {
                for (let i = 0; i < this.cunChuFiles.length; i++) {
                    const file = this.cunChuFiles[i];
                    if (file.status !== 'uploaded') {
                        await this.uploadSingleFileWithProgress(file, 'dataStorageMaterials', i, 'cunChu');
                        // 每个文件上传后都触发一次状态更新
                        this.$nextTick(() => {
                            this.triggerUploadStatusChange();
                        });
                    }
                }
                this.$message.success('所有存储文件上传完成');
            } catch (error) {
                this.$message.error('上传过程中出现错误');
            } finally {
                this.isCunChuUploading = false;
                // 最终更新上传状态
                this.updateUploadStatus();
            }
        },

        // 带进度条的文件上传方法
        async uploadSingleFileWithProgress(file, fileType, index, fileCategory) {
            console.log(`开始上传文件: ${file.name}, 类型: ${fileType}, 分类: ${fileCategory}`);

            // 先更新一次状态
            this.updateUploadStatus();

            // 更新文件状态为上传中
            this.updateFileStatus(fileCategory, index, 'uploading', 0);

            try {
                const formData = new FormData();
                formData.append('file', file.raw || file);
                formData.append('registrationId', this.registrationId);
                formData.append('type', fileType);

                const response = await this.$axios.post('/web/dataComplianceDetail/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            this.updateFileStatus(fileCategory, index, 'uploading', percentage);
                        }
                    }
                });

                if (response.data && response.data.status === 200 && response.data.object) {
                    // 上传成功
                    const uploadedUrl = response.data.object;

                    console.log(`文件上传成功: ${file.name}, URL: ${uploadedUrl}`);

                    // 更新文件状态
                    this.updateFileStatus(fileCategory, index, 'uploaded', 100);

                    // 更新文件对象的 URL
                    const fileList = this[`${fileCategory}Files`];
                    if (fileList && fileList[index]) {
                        fileList[index].url = uploadedUrl;
                        fileList[index].uploaded = true;
                        // 使用 Vue.set 确保响应式更新
                        this.$set(fileList, index, { ...fileList[index] });
                    }

                    // 添加到 uploadedFileUrls（避免重复）
                    const existingIndex = this.uploadedFileUrls.findIndex(item =>
                        item.url === uploadedUrl ||
                        (item.fileName === file.name && item.type === fileType)
                    );

                    if (existingIndex === -1) {
                        this.uploadedFileUrls.push({
                            url: uploadedUrl,
                            type: fileType,
                            fileCategory: fileCategory,
                            fileName: file.name
                        });
                        console.log(`添加到 uploadedFileUrls: ${file.name}`);
                    } else {
                        // 更新已存在的条目
                        this.uploadedFileUrls[existingIndex] = {
                            url: uploadedUrl,
                            type: fileType,
                            fileCategory: fileCategory,
                            fileName: file.name
                        };
                        console.log(`更新 uploadedFileUrls 中的条目: ${file.name}`);
                    }

                    console.log('当前 uploadedFileUrls:', this.uploadedFileUrls);

                    // 上传成功后立即触发事件通知父组件
                    this.$nextTick(() => {
                        this.triggerUploadStatusChange();
                    });

                    return uploadedUrl;
                } else {
                    throw new Error(response.data.msg || '上传失败');
                }
            } catch (error) {
                // 上传失败
                this.updateFileStatus(fileCategory, index, 'error', 0);
                this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`);
                throw error;
            } finally {
                // 无论成功失败，都更新状态
                this.$nextTick(() => {
                    this.updateUploadStatus();
                });
            }
        },
        triggerUploadStatusChange() {
            console.log('触发上传状态变化事件');

            const statusData = {
                hasUploading: this.hasUploadingFiles,
                hasUnuploaded: this.hasUnuploadedFiles,
                canProceed: !this.hasUploadingFiles && !this.hasUnuploadedFiles,
                canSubmit: this.canSubmit(),
                submitData: this.getSubmitData()
            };

            console.log('触发状态变化数据:', statusData);

            // 触发事件通知父组件
            this.$emit('upload-status-change', statusData);
            this.$emit('file-uploaded', {
                submitData: this.getSubmitData(),
                canSubmit: this.canSubmit()
            });
        },
        // 新增：获取提交数据的方法
        getSubmitData() {
            console.log('获取提交数据，当前 uploadedFileUrls:', this.uploadedFileUrls);

            // 准备提交数据
            const submitData = {
                registrationId: this.registrationId,
                qualificationMaterials: [],
                dataSourceMaterials: [],
                dataSampleMaterials: [],
                dataStorageMaterials: [],
                isSelfStorage: this.isSelfStorage,
                needBeProcessed: this.needBeProcessed
            };

            // 根据文件上传区域将URL分配到正确的字段
            this.uploadedFileUrls.forEach(item => {
                if (!item.url) return; // 跳过无效的URL

                switch (item.type) {
                    case 'qualificationMaterials':
                        if (!submitData.qualificationMaterials.includes(item.url)) {
                            submitData.qualificationMaterials.push(item.url);
                        }
                        break;
                    case 'dataSourceMaterials':
                        if (!submitData.dataSourceMaterials.includes(item.url)) {
                            submitData.dataSourceMaterials.push(item.url);
                        }
                        break;
                    case 'dataSampleMaterials':
                        if (!submitData.dataSampleMaterials.includes(item.url)) {
                            submitData.dataSampleMaterials.push(item.url);
                        }
                        break;
                    case 'dataStorageMaterials':
                        if (!submitData.dataStorageMaterials.includes(item.url)) {
                            submitData.dataStorageMaterials.push(item.url);
                        }
                        break;
                }
            });

            console.log('生成的提交数据:', submitData);
            return submitData;
        },

        // 新增：检查是否可以提交的方法
        canSubmit() {
            // 检查所有必需的文件列表是否都已上传文件
            const hasZiZhiFiles = this.ziZhiFiles.some(f => f.status === 'uploaded');
            const hasLaiYuanFiles = this.laiYuanFiles.some(f => f.status === 'uploaded');
            const hasYinSiFiles = (!this.needBeProcessed) || this.yinSiFiles.some(f => f.status === 'uploaded');
            const hasCunChuFiles = this.cunChuFiles.some(f => f.status === 'uploaded');

            const canSubmit = hasZiZhiFiles && hasLaiYuanFiles && hasYinSiFiles && hasCunChuFiles;
            console.log('检查是否可以提交:', {
                hasZiZhiFiles,
                hasLaiYuanFiles,
                hasYinSiFiles,
                hasCunChuFiles,
                needBeProcessed: this.needBeProcessed,
                canSubmit
            });

            return canSubmit;
        },


        // 新增：检查上传状态的方法
        updateUploadStatus() {
            console.log('更新上传状态，当前文件列表:', {
                ziZhiFiles: this.ziZhiFiles,
                laiYuanFiles: this.laiYuanFiles,
                yinSiFiles: this.yinSiFiles,
                cunChuFiles: this.cunChuFiles,
                uploadedFileUrls: this.uploadedFileUrls
            });

            // 检查是否有文件正在上传
            const hasUploading =
                this.ziZhiFiles.some(f => f.status === 'uploading') ||
                this.laiYuanFiles.some(f => f.status === 'uploading') ||
                this.yinSiFiles.some(f => f.status === 'uploading') ||
                this.cunChuFiles.some(f => f.status === 'uploading');

            // 检查是否有未上传的文件（状态为ready或error）
            const hasUnuploaded =
                this.ziZhiFiles.some(f => f.status === 'ready' || f.status === 'error') ||
                this.laiYuanFiles.some(f => f.status === 'ready' || f.status === 'error') ||
                (this.needBeProcessed && this.yinSiFiles.some(f => f.status === 'ready' || f.status === 'error')) ||
                this.cunChuFiles.some(f => f.status === 'ready' || f.status === 'error');

            this.hasUploadingFiles = hasUploading;
            this.hasUnuploadedFiles = hasUnuploaded;

            const statusData = {
                hasUploading: hasUploading,
                hasUnuploaded: hasUnuploaded,
                canProceed: !hasUploading && !hasUnuploaded,
                canSubmit: this.canSubmit(),
                submitData: this.getSubmitData()
            };

            console.log('上传状态:', statusData);

            // 触发事件通知父组件
            this.$emit('upload-status-change', statusData);
        },



        // 更新文件状态
        updateFileStatus(fileCategory, index, status, percentage) {
            const fileList = this[`${fileCategory}Files`];
            if (fileList && fileList[index]) {
                fileList[index].status = status;
                fileList[index].percentage = percentage;

                // 使用Vue.set确保响应式更新
                this.$set(fileList, index, { ...fileList[index] });
            }
        },

        // 模板下载
        async downloadTemplate(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('ComplianceCommitmentLetter.docx')) {
                    fileName = "自行存储合规承诺书-模板.docx"
                }

                if (customName.startsWith('OtherComplianceCommitmentLetter.docx')) {
                    fileName = "第三方存储合规承诺书-模板.docx"
                }


                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },

        // 提交表单
        async submitEvaluation() {
            //防止重复提交
            if (this.isSubmitting) {
                return;
            }

            // 检查是否有文件需要上传
            if (this.allFileList.length === 0) {
                this.$message.warning('请至少上传一个文件');
                return;
            }

            // 检查是否所有必需的文件都已上传
            const hasZiZhiFiles = this.ziZhiFiles.some(f => f.status === 'uploaded');
            const hasLaiYuanFiles = this.laiYuanFiles.some(f => f.status === 'uploaded');
            const hasYinSiFiles = (!this.needBeProcessed) || this.yinSiFiles.some(f => f.status === 'uploaded');
            const hasCunChuFiles = this.cunChuFiles.some(f => f.status === 'uploaded');

            if (!hasZiZhiFiles || !hasLaiYuanFiles || !hasYinSiFiles || !hasCunChuFiles) {
                this.$message.warning('请确保所有必需的文件都已上传完成');
                return;
            }

            // 显示提交中弹窗 
            this.submitConfirmInstance = this.$loading({
                lock: true,
                text: '正在提交文件，请勿关闭或刷新页面...',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            // 设置提交状态
            this.isSubmitting = true;

            try {
                // 准备提交数据
                const submitData = {
                    registrationId: this.registrationId,
                    qualificationMaterials: [],
                    dataSourceMaterials: [],
                    dataSampleMaterials: [],
                    dataStorageMaterials: [],
                    isSelfStorage: this.isSelfStorage,
                };

                // 根据文件上传区域将URL分配到正确的字段
                this.uploadedFileUrls.forEach(item => {
                    switch (item.type) {
                        case 'qualificationMaterials':
                            submitData.qualificationMaterials.push(item.url);
                            break;
                        case 'dataSourceMaterials':
                            submitData.dataSourceMaterials.push(item.url);
                            break;
                        case 'dataSampleMaterials':
                            submitData.dataSampleMaterials.push(item.url);
                            break;
                        case 'dataStorageMaterials':
                            submitData.dataStorageMaterials.push(item.url);
                            break;
                    }
                });

                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataComplianceDetail/add', submitData);

                if (response.data && response.data.status === 200) {
                    // 关闭提交中的弹窗
                    this.closeSubmitConfirm();
                    // 提交成功后显示确认弹窗
                    this.$confirm('提交成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataCompliance');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }

            } catch (error) {
                this.$message.error('文件上传或提交失败: ' + (error.message || '未知错误'));
            } finally {
                this.isSubmitting = false;
            }
        },

        // 关闭提交确认弹窗的方法
        closeSubmitConfirm() {
            if (this.submitConfirmInstance) {
                this.submitConfirmInstance.close();
                this.submitConfirmInstance = null;
            }
        },

        // 单个文件上传方法（兼容旧代码）
        uploadSingleFile(file, fileType) {
            const formData = new FormData();
            formData.append('file', file.raw || file);
            formData.append('registrationId', this.registrationId);
            formData.append('type', fileType);

            return this.$axios.post('/web/dataComplianceDetail/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                // 在响应中添加文件类型信息
                if (response.data && response.data.status === 200 && response.data.object) {
                    response.data.fileType = fileType; // 添加文件类型标识
                }
                return response;
            });
        }
    },
    computed: {
        isSubmitDisabled() {
            // 检查所有必需的文件列表是否都已上传文件
            const hasZiZhiFiles = this.ziZhiFiles.some(f => f.status === 'uploaded');
            const hasLaiYuanFiles = this.laiYuanFiles.some(f => f.status === 'uploaded');
            const hasYinSiFiles = (!this.needBeProcessed) || this.yinSiFiles.some(f => f.status === 'uploaded');
            const hasCunChuFiles = this.cunChuFiles.some(f => f.status === 'uploaded');

            return this.isSubmitting || !(hasZiZhiFiles && hasLaiYuanFiles && hasYinSiFiles && hasCunChuFiles);
        }
    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
}

.compliance-card {
    margin-bottom: 20px;
    border: 1px solid #EBEEF5;
}

.compliance-card-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.compliance-card-header i {
    margin-right: 8px;
    font-size: 18px;
    color: #409EFF;
}

.upload-label {
    margin-bottom: 12px;
}

.required-star {
    color: #f56c6c;
    margin-right: 4px;
}

.label-title {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
}

.label-hint {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
}

.label-hint-block {
    font-size: 13px;
    color: #606266;
    margin-top: 6px;
    line-height: 1.6;
    background: #f8f9fa;
    padding: 8px 10px;
    border-radius: 4px;
    border-left: 3px solid #DCDFE6;
    margin-bottom: 10px;
}

.file-list-title {
    margin-bottom: 10px;
    font-weight: 500;
    color: #303133;
}

.empty-file-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    height: 100px;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
}

.upload-actions {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.inline-radio-group {
    display: flex;
    align-items: center;
    padding: 4px 0;
}

.compliance-card >>> .el-upload-list {
    display: none !important;
}

.compliance-card >>> .el-upload-list--text {
    display: none !important;
}

.compliance-card >>> .el-upload-dragger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 180px;
}
</style>